module.exports = __webpack_public_path__ + "img/about-3.3ff00f92.jpg";